"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findIndexes = void 0;
const array_helper_1 = require("./array.helper");
function findIndexes(array, item, match) {
    return array.reduce((indexes, currentItem, index) => {
        if ((0, array_helper_1.isSame)(currentItem, item, match))
            indexes.push(index);
        return indexes;
    }, []);
}
exports.findIndexes = findIndexes;
